import {styled} from "@mui/material/styles";
import {Grid, Typography} from "@mui/material";

export const BookingApprovalLocation = styled(Typography)(() => ({
  marginBottom: '2em',
  borderBottom: '1px solid lightgrey',
  paddingBottom: '2em',
  width: '100%'
}));

export const BookingApprovalTable = styled(Grid)(() => ({
  marginBottom: '2em',
  columnGap: '4em'
}));

export const BookingApprovalLabel = styled(Typography)(() => ({
  fontWeight: 'bold'
}));

interface BookingApprovalStatusChipProps {
  isApproved: boolean;
}

export const BookingApprovalStatusChip = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'isApproved',
})<BookingApprovalStatusChipProps>(({theme, isApproved}) => ({
  display: 'flex',
  justifyContent: 'center',
  borderRadius: '10px',
  fontWeight: 'bold',
  marginTop: '1.5em',
  padding: '0.5em 2em 0.5em 2em',
  backgroundColor: isApproved ? theme.palette.success.main : theme.palette.warning.main,
}));
